import React from 'react';
import Routers from './router';

function App() {
  return <Routers />;
}

export default App;
